import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const PersonvernView: React.FC<RouteComponentProps> = () => {
  return (
    <div className="ods-margin-top-25 ods-grid ods-grid--gap ods-grid--center">
      <div className="ods-grid__column--12 ods-grid__column--start-3-breakpoint-medium ods-grid__column--end-11-breakpoint-medium">
        <div className="ods-status-card">
          <div className="ods-status-card__content">
            <h1 className="ods-status-card__heading">Personvernvilkår</h1>
            <p>
              Informasjonen som samles inn i dette skjemaet vil kun bli brukt til administrasjon
              og aktiviteter ved Annai Poopathi Tamilsk Aktivitet og Kultursenter - Norge
              (APTAK - Norge).
            </p>
            <p>
              Dine personopplysninger vil bli behandlet i samsvar med personvernforordningen
              (GDPR).
            </p>
            <p>
              Dataene vil kun være tilgjengelig for autoriserte personer i Annai Poopathi
              Tamilsk Aktivitet og Kultursenter - Norge (APTAK - Norge).
            </p>
             <h3 className="ods-margin-top-11">Deling av data</h3>
            <p>
              Kun nødvendige elevopplysninger vil bli delt med
              International Council for Educational Development of Tamils (ICEDT), og
              utelukkende for å administrere den generelle tamileksamenen. Ingen andre data
              vil bli delt.
            </p>

            <h3 className="ods-margin-top-11">Hvilke opplysninger vi samler inn</h3>
            <p>
              Vi lagrer kun de opplysningene du selv oppgir i registreringsskjema og
              brukerprofil — typisk navn (på norsk og tamil), fødselsdato, avdeling, klasse,
              samt foreldres e-postadresse og mobilnummer. Vi samler ikke inn opplysninger
              fra tredjeparter.
            </p>

            <h3 className="ods-margin-top-11">Hvor data lagres</h3>
            <p>
              All data lagres på servere i <strong>Europa</strong>. Webhotellet vårt leveres
              av <strong>Hetzner Online GmbH</strong> i Tyskland. Data forlater ikke EU/EØS,
              og vi overfører ikke personopplysninger til tredjeland.
            </p>

            <h3 className="ods-margin-top-11">Sikkerhet</h3>
            <p>
              All kommunikasjon mellom din nettleser og portalen krypteres med
              <strong> SSL/TLS</strong>. Pålogging skjer med engangskode (PIN) sendt på
              e-post — vi lagrer ikke passord.
            </p>

            <h3 className="ods-margin-top-11">Informasjonskapsler (cookies)</h3>
            <p>
              Vi bruker <strong>ingen tredjepartskapsler</strong>, og vi deler ikke data med
              annonsenettverk eller analyseplattformer. Innloggings­informasjon lagres
              lokalt i nettleseren din (localStorage) for å holde deg pålogget mellom besøk.
            </p>

            <h3 className="ods-margin-top-11">Dine rettigheter</h3>
            <p>
              Du har rett til innsyn i, retting av og sletting av personopplysningene vi har
              registrert om deg. Ta kontakt for å bruke disse rettighetene.
            </p>

            <h3 className="ods-margin-top-11">Kontakt</h3>
            <p>
              Spørsmål om personvern kan rettes til{' '}
              <a href="mailto:kontakt@annaipoopathi.no" className="o-kom-link">
                kontakt@annaipoopathi.no
              </a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(PersonvernView);
